document.addEventListener('DOMContentLoaded', function() {

    // Get the current URL
    const currentUrl = window.location.href;

    // Check if the URL contains '?' after '/'
    if (currentUrl.includes('/?cart-drawer')) {
    $(".mini-cart-icon-custom").attr("aria-expanded","true")
    }


const playButton = document.querySelector('.custom-video-play-main-pdp');
    const videoElement = document.querySelector('.custom-pdp-video-main video');

    if (playButton && videoElement) {
  
        playButton.addEventListener('click', function () {
            
            videoElement.play();
        });
    }
// Select all video wrapper elements
const videoWrappers = document.querySelectorAll(".custom-pdp-video-main");

videoWrappers.forEach(wrapper => {
  const videoElement = wrapper.querySelector("video");
  const playButton = wrapper.querySelector(".play-button");
  const soundButton = wrapper.querySelector(".sound-button");
  const playIcon = playButton.querySelector(".icon-play");
  const pauseIcon = playButton.querySelector(".icon-pause");
  const soundOnIcon = soundButton.querySelector(".icon-sound-on");
  const soundOffIcon = soundButton.querySelector(".icon-sound-off");

  if (!videoElement || !playButton || !soundButton || !playIcon || !pauseIcon || !soundOnIcon || !soundOffIcon) {
    return; // Skip if any required element is missing
  }

  // Initialize video with sound off and update sound icon
  videoElement.muted = true;
  soundOnIcon.style.display = 'none';
  soundOffIcon.style.display = 'block';

  // Function to update play/pause button based on video state
  const updatePlayPauseIcon = () => {
    if (videoElement.paused) {
      playIcon.style.display = 'block';
      pauseIcon.style.display = 'none';
      soundButton.style.display = 'none'; // Hide sound toggle when paused
    } else {
      playIcon.style.display = 'none';
      pauseIcon.style.display = 'block';
      soundButton.style.display = 'block'; // Show sound toggle when playing
    }
  };

  // Initial icon update
  updatePlayPauseIcon();

  // Play/Pause Button Logic
  playButton.addEventListener("click", () => {
    // Toggle play/pause for the clicked video
    if (videoElement.paused) {
      videoElement.play();
    } else {
      videoElement.pause();
    }
    updatePlayPauseIcon();
  });

  // Sound Toggle Button Logic
  soundButton.addEventListener("click", () => {
    videoElement.muted = !videoElement.muted;
    if (videoElement.muted) {
      soundOnIcon.style.display = 'none';
      soundOffIcon.style.display = 'block';
    } else {
      soundOnIcon.style.display = 'block';
      soundOffIcon.style.display = 'none';
    }
  });

  // Ensure play/pause icon is updated when video ends
  videoElement.addEventListener('pause', updatePlayPauseIcon);
  videoElement.addEventListener('play', updatePlayPauseIcon);
});
 



let isScrolling = false;
let scrollTimeout;
let lastScrollY = 0;
const minScrollDistance = 400;

function onScroll() {
  const currentScrollY = window.scrollY;
  const scrollDistance = Math.abs(currentScrollY - lastScrollY);

  if (scrollDistance >= minScrollDistance) {
    lastScrollY = currentScrollY; // Update the last scroll position

    if (!isScrolling) {
      
      pauseAllVideos(); // Pause all videos when scrolling starts
      isScrolling = true;
    }

    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(() => {
      isScrolling = false;
    }, 10); // Reset after 100ms of no scrolling
  }
}

function pauseAllVideos() {
  const videos = document.querySelectorAll('video');
  videos.forEach(video => {
    if (!video.paused) {
      video.pause(); // Pause the video if it's playing
     
    }
  });
}

window.addEventListener('scroll', onScroll);




// Function to handle tooltip click event
function handleTooltipClick(event) {
    const tooltipText = event.currentTarget.querySelector('.tooltiptext');
    if (tooltipText.style.visibility === 'hidden') {
        tooltipText.style.visibility = 'visible';
    } else {
        tooltipText.style.visibility = 'hidden';
    }
}

// Media query to check screen width
const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
let isMobile = mobileMediaQuery.matches; // Initial check

// Function to update event listeners based on screen size
function updateTooltipBehavior() {
    const tooltip = document.querySelector('.tooltip');

    if (!tooltip) return;
    if (mobileMediaQuery.matches) {
      // Add click event listener if mobile
      if (!tooltip.onclick) {
        tooltip.addEventListener('click', handleTooltipClick);
      }
    } else {
      // Remove click event listener if not mobile
      tooltip.removeEventListener('click', handleTooltipClick);
      const tooltipText = tooltip.querySelector('.tooltiptext');
      if (tooltipText) {
        tooltipText.style.visibility = 'hidden'; // Reset visibility
      }
    }
}

// Listen for screen size changes
mobileMediaQuery.addEventListener('change', updateTooltipBehavior);

// Initial setup
updateTooltipBehavior();
 });


// ---------------------------------- Start - Mengen Bundle als Upsell ----------------------------------

document.addEventListener('click', (event) => {
  const isLineVariant = event.target.closest('.line_item_variant_name');
  if(isLineVariant){
    LineVariantChange(isLineVariant);
  }
});

function LineVariantChange(button) {

  const drawer_overlay = document.querySelector('.car_drawer_overlay');
  drawer_overlay.classList.add('active_overlay');

  const remove_key = button.getAttribute('remove_key'); // line item key
  const add_id = button.getAttribute('add_id'); // variant id
  const item__quantity = parseInt(button.getAttribute('item__quantity')); // Line Item Quantity

  if (!remove_key || !add_id) return;

  // Add new variant
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: add_id,
      quantity: item__quantity
    })
  })
  .then(res => res.json())
  .then(addedItem => {
    //console.log("Added new item:", addedItem);

    // Remove old item
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: remove_key,
        quantity: 0 
      })
    });
  })
  .then(res => res.json())
  .then((updatedCart) => {
    //console.log("Removed old item. Updated cart:", updatedCart);
    return cartRefresh(); // return promise
  })
  .then(() => {
    drawer_overlay.classList.remove('active_overlay');
  })
  .catch(err => console.error("Cart update error:", err));
}


// ---------------------------------- End - Mengen Bundle als Upsell ----------------------------------

// ----------------- Start - Variantenauswahl auf der PDP ------------------

document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.bs-swatch__item');
  if (!swatch) return; 

  const parent = swatch.closest('[data-selector-type]');
  if (!parent) return;

  parent.querySelectorAll('.bs-swatch__item').forEach((item) => {
    item.classList.remove('active_block_swatch');
  });
  swatch.classList.add('active_block_swatch');

  const select = parent.querySelector('select');
  if (!select) return;

  const selectedValue = swatch.getAttribute('value');

  select.querySelectorAll('option').forEach((option) => {
    if (option.value === selectedValue) {
      option.selected = true;

      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});

// ----------------- End - Variantenauswahl auf der PDP ------------------
class ShortcodeFaq extends HTMLElement {
  connectedCallback() {
    const questions = this.querySelectorAll('.faq-question');
    questions.forEach((button) => {
      button.addEventListener('click', function () {
        const expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !expanded);
        const answer = document.getElementById(this.getAttribute('aria-controls'));
        if (answer) {
          answer.hidden = expanded;
        }
        // Toggle icon active class for rotation
        const icon = this.querySelector('.faq-toggle-icon');
        if (icon) {
          if (!expanded) {
            icon.classList.add('active');
          } else {
            icon.classList.remove('active');
          }
        }
      });
    });
  }
}

customElements.define('shortcode-faq', ShortcodeFaq);